/* Handle permalinks for subscription product variants.
 ** NOTE: Non subscription product variants can use standard Shopify permalinks.
 ** eg: https://{shop}.myshopify.com/cart/{variant_id}:{qty}(,{variant_id}:{qty})?discount={CODE}
 ** Example: https://your-shop.myshopify.com/cart?subscribe=44846156841014:1:1475051574?discount=SAVE15
 */

/**
 * @param {string} paramStr
 * @returns {Array<{id: number, quantity: number, selling_plan?: number}>}
 *
 *
 * URL formats supported (examples):
 * ?subscribe=1234567890:1:98765,1112223334:2:98766&discount=SAVE15
 * where subscribe=variantId:qty:sellingPlanId (comma-separated, variantId and sellingPlanId are numbers)
 
 */
const parseItems = (paramStr) => {
  return paramStr
    ? paramStr
        .split(",")
        .map((chunk) => {
          const [idStr, qtyStr, spStr] = chunk.split(":");
          const id = Number(idStr);
          const quantity = Number(qtyStr || 1);
          const selling_plan = spStr ? Number(spStr) : undefined;

          return { id, quantity, selling_plan };
        })
        .filter(({ id, quantity }) => Number.isFinite(id) && quantity > 0)
        .map(({ id, quantity, selling_plan }) => {
          const line = { id, quantity };
          return selling_plan ? { ...line, selling_plan } : line;
        })
    : [];
};

/**
 *
 * @param {Array<{id: number, quantity: number, selling_plan?: number}>} items
 */
const addItemsToCart = async (items) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => {
    controller.abort();
  }, 10000);
  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ items }),
    signal: controller.signal,
  });
  clearTimeout(timeoutId);
  if (!response.ok) {
    const txt = await response.text();
    throw new Error(`Failed to add items to cart: ${txt}`);
  }
};

/**
 *
 * @param {URL} url
 */
const applyDiscount = async (url) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => {
    controller.abort();
  }, 10000);
  const queryStr = new URLSearchParams(url.search);
  const discount = queryStr.get("discount");
  if (!discount) {
    return;
  }
  const response = await fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ discount }),
    signal: controller.signal,
  });
  clearTimeout(timeoutId);
  if (!response.ok) {
    const txt = await response.text();
    throw new Error(`Failed to apply discount: ${txt}`);
  }
};

const parseUrl = async () => {
  try {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const subscribe = params.get("subscribe");
    if (!subscribe) {
      return;
    }

    const items = parseItems(subscribe);
    if (items.length === 0) {
      return;
    }

    await addItemsToCart(items);
    await applyDiscount(url);

    window.location.href = "/checkout";
  } catch (error) {
    console.error("Error parsing URL:", error);
    // fallback to home page
    window.location.href = "/";
  }
};

const init = () => {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", parseUrl);
  } else {
    parseUrl();
  }
};

init();
